<div class="global-app-content" id="vi_global_view">
  <div class="global-view-container">
    <div class="filter">
      <div class="filter-container">
        <div class="header-container">
          <p class="header">Filter by</p>
        </div>
        <div class="filter-option">
          <mat-expansion-panel [expanded]="true" class="date-time-selector-container">
            <mat-expansion-panel-header class="date-time-selector">
              <p class="date-time-header">Date & Time</p>
            </mat-expansion-panel-header>
            <div class="vi-global-view-custom-radio-group">
              <slb-radio-button-group
                class="date-range"
                [isVertical]="false"
                [values]="customOption"
                [(ngModel)]="selectedOption"
                [disabled]="calendarDisabled || (globalEvent && globalEvent.isLoading)"
                (valueChanged)="onCustom()"></slb-radio-button-group>
            </div>
            <div class="calendar-container" [formGroup]="formGroup">
              <div class="start-date-holder" *ngIf="selectedOption === 'custom'">
                <mat-form-field slbFormField class="calendar">
                  <mat-label>From</mat-label>
                  <input
                    formControlName="startDate"
                    [(ngModel)]="custStartDate"
                    (formattedValueChange)="formattedCalendar = $event"
                    id="custom_calendar_dialog_startDate"
                    (valueChange)="calendarEvent = $event"
                    [slbDateTimePicker]="dateTimePicker"
                    (ngModelChange)="validateCalendar()"
                    [max]="todayDate"
                    [placeholder]="calendarPlaceholder"
                    (keypress)="validateCalendarKeys($event)"
                    matInput />
                  <slb-date-time-picker-toggle
                    [for]="dateTimePicker"
                    matSuffix
                    [disabled]="!getEnableCalendar || (globalEvent && globalEvent.isLoading)">
                  </slb-date-time-picker-toggle>
                  <slb-date-time-picker-popup #dateTimePicker></slb-date-time-picker-popup>
                </mat-form-field>
              </div>
              <div class="end-date-holder" *ngIf="selectedOption === 'custom'">
                <mat-form-field slbFormField class="calendar">
                  <mat-label>To</mat-label>
                  <input
                    formControlName="endDate"
                    [(ngModel)]="custEndDate"
                    (formattedValueChange)="formattedCalendar = $event"
                    id="custom_calendar_dialog_endDate"
                    (valueChange)="calendarEvent = $event"
                    (ngModelChange)="validateCalendar()"
                    [slbDateTimePicker]="dateTimePicker1"
                    [max]="todayDate"
                    [placeholder]="calendarPlaceholder"
                    (keypress)="validateCalendarKeys($event)"
                    matInput />
                  <slb-date-time-picker-toggle [for]="dateTimePicker1" matSuffix [disabled]="!getEnableCalendar">
                  </slb-date-time-picker-toggle>
                  <slb-date-time-picker-popup #dateTimePicker1></slb-date-time-picker-popup>
                </mat-form-field>
              </div>
              <div class="error-holder">
                <mat-error *ngIf="isRequired">Please fill the required field</mat-error>
                <mat-error *ngIf="endDateError">End date should be greater than the start date</mat-error>
                <mat-error *ngIf="currentDateError">Start date and end date should be less than the current date</mat-error>
              </div>
            </div>
            <slb-radio-button-group
              class="date-range"
              [isVertical]="true"
              (ngModelChange)="onSwitchDays($event)"
              [(ngModel)]="selectedDateRange"
              [disabled]="calendarDisabled || (globalEvent && globalEvent.isLoading)"
              [values]="dateRange"></slb-radio-button-group>
          </mat-expansion-panel>
          <mat-expansion-panel [expanded]="true" class="workflow-selector-container">
            <mat-expansion-panel-header class="workflow-selector">
              <p class="workflow-header">Workflow</p>
            </mat-expansion-panel-header>
            <div class="checkbox-option" *ngFor="let item of workFlowItems; let i = index">
              <mat-checkbox
                [(ngModel)]="item.checked"
                (change)="filter(item.name, $event.checked, workFlowItems, 'workflow')"
                [disabled]="globalEvent && globalEvent.isLoading"
                >{{ item.name }}</mat-checkbox
              >
            </div>
          </mat-expansion-panel>
          <mat-expansion-panel [expanded]="true" class="activity-selector-container">
            <mat-expansion-panel-header class="activity-selector">
              <p class="activity-header">Activity Type</p>
            </mat-expansion-panel-header>
            <div class="checkbox-option" *ngFor="let item of allActivities; let i = index">
              <mat-checkbox
                [(ngModel)]="item.checked"
                (change)="filter(item.name, $event.checked, allActivities, 'profileTypeIds')"
                [disabled]="disableActivityInFilters || (globalEvent && globalEvent.isLoading)"
                >{{ item.name }}</mat-checkbox
              >
            </div>
          </mat-expansion-panel>
          <mat-expansion-panel [expanded]="true" class="site-selector-container">
            <mat-expansion-panel-header class="site-selector">
              <p class="site-header">Country</p>
            </mat-expansion-panel-header>
            <div class="checkbox-option" *ngFor="let item of countryList; let i = index">
              <mat-checkbox
                [(ngModel)]="item.checked"
                (change)="filter(item.name, $event.checked, countryList, 'country')"
                [disabled]="globalEvent && globalEvent.isLoading"
                >{{ item.name }}</mat-checkbox
              >
            </div>
          </mat-expansion-panel>
          <mat-expansion-panel [expanded]="true" class="site-selector-container">
            <mat-expansion-panel-header class="site-selector">
              <p class="site-header">Gateways</p>
            </mat-expansion-panel-header>
            <div class="checkbox-option" *ngFor="let item of allGateways; let i = index">
              <mat-checkbox
                [(ngModel)]="item.checked"
                (change)="filter(item.name, $event.checked, allGateways, 'gateway'); onGatewayChange()"
                [disabled]="globalEvent && globalEvent.isLoading"
                >{{ item.name }}</mat-checkbox
              >
            </div>
          </mat-expansion-panel>
          <mat-expansion-panel [expanded]="true" class="site-selector-container">
            <mat-expansion-panel-header class="site-selector">
              <p class="site-header">Cameras</p>
            </mat-expansion-panel-header>
            <div class="checkbox-option" *ngFor="let item of allEquipments; let i = index">
              <mat-checkbox
                [(ngModel)]="item.checked"
                (change)="filter(item.name, $event.checked, allEquipments, 'equipment')"
                [disabled]="globalEvent && globalEvent.isLoading"
                >{{ item.name }}</mat-checkbox
              >
            </div>
          </mat-expansion-panel>
          <mat-expansion-panel [expanded]="true" class="site-selector-container">
            <mat-expansion-panel-header class="site-selector">
              <p class="site-header">Event Status</p>
            </mat-expansion-panel-header>
            <div class="checkbox-option" *ngFor="let item of eventStatusItems; let i = index">
              <mat-checkbox
                [(ngModel)]="item.checked"
                (change)="filter(item.name, $event.checked, eventStatusItems, 'event')"
                [disabled]="globalEvent && globalEvent.isLoading"
                >{{ item.name }}</mat-checkbox
              >
            </div>
          </mat-expansion-panel>
          <mat-expansion-panel [expanded]="true" class="site-selector-container">
            <mat-expansion-panel-header class="site-selector">
              <p class="site-header">Violation Type</p>
            </mat-expansion-panel-header>
            <div class="checkbox-option" *ngFor="let item of riskDataList; let i = index">
              <mat-checkbox
                [(ngModel)]="item.checked"
                (change)="filter(item.name, $event.checked, riskDataList, 'risk')"
                [disabled]="globalEvent && globalEvent.isLoading"
                >{{ item.name }}</mat-checkbox
              >
            </div>
          </mat-expansion-panel>
        </div>
        <div class="footer-button">
          <button
            class="clear-btn"
            slb-secondary-button
            type="button"
            (click)="onClear()"
            [disabled]="!filterValueChange || disableResetClicked">
            Clear
          </button>
          <button class="apply-btn" slb-button (click)="apply()" [disabled]="!filterValueChange">Apply</button>
        </div>
      </div>
    </div>
    <div class="chart-event-container">
      <div class="multiple-chart-container">
        <app-global-charts [workflow]="workflowResponse" [allEquipments]="allEquipments"></app-global-charts>
      </div>
      <div class="event-container">
        <app-global-event></app-global-event>
      </div>
    </div>
  </div>
</div>
